module.exports = __webpack_public_path__ + "img/pause-icon.4e4565e0.png";